module.exports = __webpack_public_path__ + "static/jason-bd66420a9ce4f75d5c561f985a451d19.png";